import {
  ApolloClient,
  InMemoryCache,
  from,
  type DocumentNode,
  type FetchResult
} from '@apollo/client/core'
import { getToken, refreshIdToken } from './authUtil'
import { createAuthLink, createAuthErrorLink, createHttpLink } from './linkHelpers'

const HASURA_END_POINT = import.meta.env.VITE_HASURA_END_POINT

export class GraphQLClientUi {
  private static client: ApolloClient<any> | undefined = undefined
  private constructor() {}

  public static init(): void {
    const authLink = createAuthLink(getToken())
    const errorLink = createAuthErrorLink({ getTokenFunc: refreshIdToken })
    const httpLink = createHttpLink(HASURA_END_POINT)
    GraphQLClientUi.client = new ApolloClient({
      link: from([authLink, errorLink, httpLink]),
      cache: new InMemoryCache()
    })
  }

  public static getInstance(forceNewInstance: boolean = false): ApolloClient<any> {
    if (forceNewInstance || GraphQLClientUi.client === undefined) {
      this.init()
    }
    return GraphQLClientUi.client! // Safe because init set client.
  }

  public static async executeMutation<T>(
    mutation: DocumentNode,
    variables?: Record<string, any>,
    forceNewInstance: boolean = false
  ): Promise<FetchResult<T>> {
    if (forceNewInstance) {
      await refreshIdToken()
    }
    const client = GraphQLClientUi.getInstance(forceNewInstance)
    return client.mutate<T>({ mutation, variables })
  }

  public static async executeQuery<T>(
    query: DocumentNode,
    variables?: Record<string, any>,
    forceNewInstance: boolean = false
  ): Promise<FetchResult<T>> {
    if (forceNewInstance) {
      await refreshIdToken()
    }
    const client = GraphQLClientUi.getInstance(forceNewInstance)
    return client.query<T>({ query, variables, fetchPolicy: 'no-cache' })
  }
}
